import { ReactNode } from 'react';
import { twJoin } from 'tailwind-merge';

type Props = {
  children?: ReactNode;
  compressed?: boolean;
};

export const ModalFooter = ({ children, compressed }: Props) => {
  return (
    <div
      className={twJoin(
        'flex items-center p-6 space-x-2',
        !compressed ? 'border-t border-gray-200 rounded-b dark:border-gray-600' : 'pt-0 justify-center',
      )}
    >
      {children}
    </div>
  );
};
